(() => {
  const params = new URLSearchParams(window.location.search);
  const rawArtworkUrl = params.get("url") || params.get("artwork");
  if (!rawArtworkUrl) return;

  let artworkUrl;
  try {
    const parsedUrl = new URL(rawArtworkUrl, window.location.href);
    const isLocalHttp =
      parsedUrl.protocol === "http:" &&
      ["127.0.0.1", "localhost"].includes(parsedUrl.hostname);

    if (parsedUrl.protocol !== "https:" && !isLocalHttp) {
      throw new Error("Only HTTPS artwork URLs are supported");
    }

    artworkUrl = parsedUrl.href;
  } catch (error) {
    console.warn("[HAPPYNEON] Invalid custom artwork URL.", error);
    return;
  }

  const artworkFieldName = "properties[Custom Artwork]";
  let updateQueued = false;
  let previewReady = false;
  let propertyReady = false;

  const setAttributeIfChanged = (element, name, value) => {
    if (element.getAttribute(name) !== value) {
      element.setAttribute(name, value);
    }
  };

  const syncPhotoswipeDimensions = (image) => {
    if (!image.naturalWidth || !image.naturalHeight) return;
    setAttributeIfChanged(image, "data-photoswipe-width", String(image.naturalWidth));
    setAttributeIfChanged(image, "data-photoswipe-height", String(image.naturalHeight));
  };

  const updateProductPreview = () => {
    const image =
      document.querySelector(
        ".product-main-slide.starting-slide [data-product-image-main] img.photoswipe__image"
      ) ||
      document.querySelector(
        ".product-main-slide:first-child [data-product-image-main] img"
      ) ||
      document.querySelector("[data-product-image-main] img");

    if (!image) return false;

    const wrapper = image.closest(".image-wrap") || image.parentElement;
    wrapper?.classList.add("hn-custom-artwork-preview");
    image.classList.add("hn-custom-artwork-preview__image");
    image.alt = "Your custom neon artwork preview";

    if (image.getAttribute("src") !== artworkUrl) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = artworkUrl;
    }

    setAttributeIfChanged(image, "data-photoswipe-src", artworkUrl);

    if (image.complete) {
      syncPhotoswipeDimensions(image);
    } else {
      image.addEventListener("load", () => syncPhotoswipeDimensions(image), {
        once: true,
      });
    }

    previewReady = true;
    return true;
  };

  const updateArtworkFields = () => {
    const fields = Array.from(document.getElementsByName(artworkFieldName));
    if (!fields.length) return false;

    fields.forEach((field) => {
      if (field.value !== artworkUrl) {
        field.value = artworkUrl;
        field.dispatchEvent(new Event("input", { bubbles: true }));
        field.dispatchEvent(new Event("change", { bubbles: true }));
      }

      field.readOnly = true;
      field.setAttribute("readonly", "readonly");
    });

    propertyReady = true;
    return true;
  };

  const update = () => {
    updateQueued = false;
    updateProductPreview();
    updateArtworkFields();
  };

  const queueUpdate = () => {
    if (updateQueued) return;
    updateQueued = true;
    window.requestAnimationFrame(update);
  };

  update();

  const observerRoot = document.querySelector("#MainContent") || document.body;
  if (observerRoot) {
    const observer = new MutationObserver(queueUpdate);
    observer.observe(observerRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "srcset", "value"],
    });
  }

  window.setTimeout(() => {
    if (!previewReady) {
      console.warn("[HAPPYNEON] The custom artwork preview image was not found.");
    }
    if (!propertyReady) {
      console.warn(
        `[HAPPYNEON] The third-party field "${artworkFieldName}" was not found.`
      );
    }
  }, 15000);
})();
